import request from "./request";

//产品下拉
export const getPros = (data) => request("/pro/getPros", data, "POST_JSON");
//渠道下拉
export const getMedias = () => request("/pro/getMedias", null, "POST");
//地区下拉
export const countrys = (data) => request("/pro/countrys", data, "POST");
//查询
export const ltvPredict = (data) => request("/bi/ltvPredict", data, "POST");